import { getCdnImageSrc, HStack, VStack } from "goi_common";
import Image from "next/image";

export default function MoreFacilityImage({
  name,
  images,
}: {
  name: string;
  images: Array<any>;
}) {
  return (
    <VStack gap={10}>
      <div className="subtitle3">더 많은 시설 사진</div>
      <VStack overflow="scroll" width="100%">
        <HStack gap={8} width="100%">
          {images.map((res) => (
            <VStack
              position="relative"
              width="120px"
              height="120px"
              alignItems="center"
              justifyContent="center"
              borderRadius="5px"
              overflow="hidden"
              css={{ flexShrink: 0 }}
              key={res.id}
            >
              <Image
                fill
                priority={true}
                alt={name}
                loading="eager"
                style={{ objectFit: "cover", objectPosition: "center" }}
                src={getCdnImageSrc(res.url)}
              />
            </VStack>
          ))}
        </HStack>
      </VStack>
    </VStack>
  );
}
